export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/50 via-background-50 to-accent-50/30"></div>

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5 whitespace-nowrap">
              久久视频 · 芒果视频 · 97视频 · 丝瓜视频
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 font-heading leading-tight mb-5">
              国产91视频 - 综合在线视频资源导航平台
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              国产91视频致力于为广大用户汇集久久视频、芒果视频、97视频、丝瓜视频、蓝莓视频等优质在线视频资源网站。平台每日更新最新视频资源入口，提供视频播放器在线看视频服务，让您一站畅享海量精彩内容。当前覆盖视频资源站点超过200个，每日资源更新量持续增长，为您打造高效便捷的在线看视频体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-600 text-lg"></i>
                </div>
                <span className="text-sm text-foreground-700 font-medium whitespace-nowrap">每日资源持续更新</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-links-line text-primary-600 text-lg"></i>
                </div>
                <span className="text-sm text-foreground-700 font-medium whitespace-nowrap">200+ 视频站点覆盖</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-secondary-700 text-lg"></i>
                </div>
                <span className="text-sm text-foreground-700 font-medium whitespace-nowrap">安全稳定访问保障</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                开始浏览资源
              </a>
              <a
                href="#about"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-background-100 text-foreground-700 rounded-lg font-semibold text-sm hover:bg-background-200 transition-colors cursor-pointer border border-background-200"
              >
                <i className="ri-information-line"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20digital%20entertainment%20portal%20with%20floating%20play%20buttons%20and%20cinematic%20elements%2C%20soft%20crimson%20and%20amber%20gradient%20atmosphere%2C%20modern%20minimal%20design%20with%20geometric%20patterns%2C%20clean%20composition%2C%20no%20text%2C%20technology%20and%20media%20aesthetic%2C%20warm%20lighting%2C%20professional%20quality&width=1040&height=780&seq=hero-main-2026&orientation=landscape"
                alt="国产91视频在线视频资源导航平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}